import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ReactFlow, applyNodeChanges, applyEdgeChanges } from '@xyflow/react';
import { nodeTypes } from '../nodeTypes';
import XScrollWrapper from '../../XScrollWrapper';
import { useProjectState } from '@starflow/app/store';
import { dealHanders, dealLocation, FLOW_HEIGHT } from './utils';
import FlowLabelEditor from '../FlowLabelEditor';
import FlowBtnGroup from '../FlowBtnGroup';
import './def.scss';

export const X_DISTANCE = 250;
export const FLOW_WIDTH = 170; // 单节点宽度
export const FLOW_PADDING_Y = 8;

const Flow = React.memo(({ flow, sortNum }) => {
  const flowScale = useProjectState('flowScale');
  const autoRunningFlowId = useProjectState('autoRunningFlowId');
  const [nodes, setNodes] = useState();
  const [edges, setEdges] = useState();
  const [singleNodeH, setSingleNodeH] = useState(FLOW_HEIGHT);
  const row = useRef(0);
  const col = useRef(0);
  useEffect(() => {
    if (!flow.data) return;
    const { newNodes, edgeLists, rows, singleNodeHeight } = formatData(flow.data);
    setNodes(newNodes);
    setEdges(edgeLists);
    setSingleNodeH(singleNodeHeight);
    row.current = rows;
  }, [flow]);

  // 遍历位置
  const formatData = useCallback(
    ({ edge_lists, nodes }) => {
      return dealLocation(dealHanders(nodes, edge_lists || []), col);
    },
    [flow],
  );

  const onNodesChange = useCallback((changes) => setNodes((nds) => applyNodeChanges(changes, nds)), []);
  const onEdgesChange = useCallback((changes) => setEdges((eds) => applyEdgeChanges(changes, eds)), []);
  return (
    <div
      className="w-full flex-shrink-0 cursor-pointer"
      style={{ height: `${singleNodeH * row.current * flowScale + FLOW_PADDING_Y}px` }}
      draggable
      data-num={sortNum}
    >
      {nodes && edges ? (
        <div className="flex h-full relative">
          {autoRunningFlowId === flow.flowId ? <div className="absolute w-1 h-full bg-[#009DFF]" /> : null}
          <div
            className={`w-[${FLOW_WIDTH}px] border-r-[1px] border-[#EBEBEB] flex-shrink-0 bg-white h-full `}
            style={{ borderBottom: '1px solid #E8E8E8' }}
          >
            <div
              className="flex justify-center items-center flex-col w-full h-full"
              style={{ transform: `scale(${flowScale > 1.5 ? 1.5 : flowScale < 0.8 ? 0.8 : flowScale})` }}
            >
              <FlowLabelEditor flow={flow} />
              <FlowBtnGroup flow={flow} autoRunningFlowId={autoRunningFlowId} />
            </div>
          </div>
          <XScrollWrapper offsetW={150} innerW={(col.current + 1) * X_DISTANCE * flowScale}>
            <ReactFlow
              nodesDraggable={false}
              panOnDrag={false}
              viewport={{ zoom: flowScale, x: 0, y: 0 }}
              fitView={false}
              deleteKeyCode={null}
              panOnScrollMode="vertical"
              preventScrolling={false}
              nodes={nodes}
              nodeTypes={nodeTypes}
              onNodesChange={onNodesChange}
              edges={edges}
              onEdgesChange={onEdgesChange}
            ></ReactFlow>
          </XScrollWrapper>
        </div>
      ) : null}
    </div>
  );
});

export default Flow;
